import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegistrationComponent } from './registration/registration.component';
import { LoginComponent } from './login/login.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { TermsandconditionComponent } from './termsandcondition/termsandcondition.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ServiceAgreementComponent } from './service-agreement/service-agreement.component';
import { MfaChallengeComponent } from './mfa/mfa-challenge.component';
import { AuthGuard } from './auth/auth.guard';
import { MaintenanceComponent } from './maintenance/maintenance.component';


const routes: Routes = [
  { path: 'maintenance', component: MaintenanceComponent, pathMatch: 'full' },
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  { path: 'signup', component: RegistrationComponent, pathMatch: 'full' },
  { path: 'forget-password', component: ForgetPasswordComponent, pathMatch: 'full' },
  { path: 'terms-and-conditions', component: TermsandconditionComponent, pathMatch: 'full' },
  { path: 'privacy-policy', component: PrivacyPolicyComponent, pathMatch: 'full' },
  { path: 'service-agreement', component: ServiceAgreementComponent, pathMatch: 'full' },
  { path: 'mfa-challenge', component: MfaChallengeComponent, canActivate: [AuthGuard], pathMatch: 'full' },
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule), canActivate: [AuthGuard] },
  { path: 'system-admin', loadChildren: () => import('./system-admin/system-admin.module').then(m => m.SystemAdminModule), canActivate: [AuthGuard] },
  { path: '', loadChildren: () => import('./mainsystem/mainsystem.module').then(m => m.MainsystemModule), canActivate: [AuthGuard]  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule {

 }
